import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../forum/app';
import username from '../../common/helpers/username';
import Dropdown from '../../common/components/Dropdown';
import LinkButton from '../../common/components/LinkButton';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
import Separator from '../../common/components/Separator';
import extractText from '../../common/utils/extractText';
import Avatar from '../../common/components/Avatar';
/**
 * The `SessionDropdown` component shows a button with the current user's
 * avatar/name, with a dropdown of session controls.
 */
export default class SessionDropdown extends Dropdown {
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    attrs.className = 'SessionDropdown';
    attrs.buttonClassName = 'Button Button--user Button--flat';
    attrs.menuClassName = 'Dropdown-menu--right';
    attrs.accessibleToggleLabel = extractText(app.translator.trans('core.forum.header.session_dropdown_accessible_label'));
  }
  view(vnode) {
    return super.view(_objectSpread(_objectSpread({}, vnode), {}, {
      children: this.items().toArray()
    }));
  }
  getButtonContent() {
    const user = app.session.user;
    return [m(Avatar, {
      user: user
    }), ' ', m("span", {
      className: "Button-label"
    }, m("span", {
      className: "Button-labelText"
    }, username(user)))];
  }

  /**
   * Build an item list for the contents of the dropdown menu.
   */
  items() {
    const items = new ItemList();
    const user = app.session.user;
    items.add('profile', m(LinkButton, {
      icon: "fas fa-user",
      href: app.route.user(user)
    }, app.translator.trans('core.forum.header.profile_button')), 100);
    items.add('settings', m(LinkButton, {
      icon: "fas fa-cog",
      href: app.route('settings')
    }, app.translator.trans('core.forum.header.settings_button')), 50);
    if (app.forum.attribute('adminUrl')) {
      items.add('administration', m(LinkButton, {
        icon: "fas fa-wrench",
        href: app.forum.attribute('adminUrl'),
        target: "_blank"
      }, app.translator.trans('core.forum.header.admin_button')), 0);
    }
    items.add('separator', m(Separator, null), -90);
    items.add('logOut', m(Button, {
      icon: "fas fa-sign-out-alt",
      onclick: app.session.logout.bind(app.session)
    }, app.translator.trans('core.forum.header.log_out_button')), -100);
    return items;
  }
}
flarum.reg.add('core', 'forum/components/SessionDropdown', SessionDropdown);